var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"food-types",on:{"click":_vm.typeClick}},[_c('div',[_c('img',{attrs:{"src":require('../assets/' + _vm.food.imgName + '.jpg'),"alt":""}}),_c('h4',{staticClass:"name"},[_vm._v(_vm._s(_vm.food.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }